export class ActionResultModel{
    public type: number;
    public message: string;
    public recordId?: number;
    constructor(){
        this.type=0;
        this.message='';
    }
}